import { useEffect } from 'react';
import { connect, ConnectedProps } from 'react-redux';

import Logger from '../../modules/logger';
import { load } from '../helpers/auth0';
import { handleForceDisableCookie, checkIfSSOIsEnabled } from '../helpers/sso';
import { authenticate as authenticateAction } from '../store/actions';

const mapDispatch = { authenticate: authenticateAction };
const connector = connect(null, mapDispatch);

type PropsFromRedux = ConnectedProps<typeof connector>;

type Props = PropsFromRedux & { navigateTo: (path: string) => void };

const pathOnLoad = location.pathname;

const init = async ({
  authenticate,
  navigateTo,
}: Pick<Props, 'authenticate' | 'navigateTo'>) => {
  await load();
  await authenticate();

  if (pathOnLoad === location.pathname) {
    // Reload the router, so that we end up on the page we originally started
    // even if that page required a user to be logged in
    navigateTo(location.pathname);
  }
};

export const Auth = ({ authenticate, navigateTo }: Props): JSX.Element => {
  useEffect(() => {
    handleForceDisableCookie();

    if (checkIfSSOIsEnabled()) {
      init({ authenticate, navigateTo }).catch(Logger.error);
    }
  }, [authenticate, navigateTo]);

  return null;
};

export default connector(Auth);
